import { useCallback } from 'react'
import { FieldValues, FieldPathValue, useController, UseControllerProps, useFormContext } from 'react-hook-form'

import PhoneNumberInput, { PhoneNumberInputProps } from '../inputs/PhoneNumberInput'

type PhoneNumberInputControllerProps<T extends FieldValues> = UseControllerProps<T> & Omit<PhoneNumberInputProps, 'onChange' | 'value'>

export default function PhoneNumberInputController<T extends FieldValues>(props: PhoneNumberInputControllerProps<T>) {
  const { control, label, name, onCountryChange } = props

  const {
    field,
    fieldState: { error },
  } = useController({
    name,
    control,
  })
  const { setValue } = useFormContext<T>()

  const handleChange = useCallback(
    (value?: string) => {
      setValue(name, (value || '') as FieldPathValue<T, typeof name>, { shouldValidate: true })
    },
    [name, setValue]
  )

  return (
    <PhoneNumberInput
      error={!!error}
      helperText={error?.message}
      label={label}
      name={field.name}
      onChange={handleChange}
      onCountryChange={onCountryChange}
      onBlur={(e) => {
        console.log('hfaukrghlgh')
        field.onBlur()
      }}
      value={field.value}
    />
  )
}
